import { render, staticRenderFns } from "./appLists.vue?vue&type=template&id=649ac66e&scoped=true&"
import script from "./appLists.vue?vue&type=script&lang=js&"
export * from "./appLists.vue?vue&type=script&lang=js&"
import style0 from "./appLists.vue?vue&type=style&index=0&id=649ac66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ac66e",
  null
  
)

export default component.exports